import { type BasePerformanceRequestFilterParams } from "features/Library/Common/models";
import { sendExportRequest } from "features/Library/Common/utils/performanceUtils";
import groupsDataService from "features/People/services/groupsDataService";

export const getGroupExport = (params: BasePerformanceRequestFilterParams, groupId: number) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => groupsDataService.getFlowUsersExport(params, groupId),
    "Flow Users Export",
    abortController,
  );
};
